export const LOGIN_URL = '/myaccount.asp';
export const REGISTER_URL = '/myaccount.asp#registration';
export const MY_NOTINO_BENEFIT_PAGE = '/mynotino/my-benefits/';

export const STANDARD_MODAL_IMAGE_PATH =
  'https://cdn.notinoimg.com/images/gallery/loyalty/vip-modal.jpg';
export const RETINA_MODAL_IMAGE_PATH =
  'https://cdn.notinoimg.com/images/gallery/loyalty/vip-modal-retina.jpg';
